export default __webpack_public_path__ + "static/Gilroy-Bold-390fb1506ba4436b844a0d796d431498.woff2";